<template>
  <v-app :class="darkMode ? '' : 'la-creme'" class="d-flex" >
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="6">
          <GoogleLogin></GoogleLogin>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import GoogleLogin from "../components/GoogleLogin";

export default {
  name: 'LoginView',
  props:{
    darkMode:{
      type:Boolean,
      default: false
    },
  },
  components:{
    GoogleLogin
  }
}
</script>

<style lang="scss" scoped>
</style>